'use client';

import customAlert from '@/util/customAlert';
import { useContext, useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import addhome_ko from "@/public/image/etc/add_home_ko.png"
import addhome_en from "@/public/image/etc/add_home_en.png"
import { SignContext } from '@/context/signContext';
import { DeviceContext } from '@/context/deviceContext';
import redirectInappToChrome from '@/util/redirectInappToChrome';
import { useLocale, useTranslations } from 'next-intl';
import { useInstallPromptContext } from '@/context/InstallPromptInitializer';
import useInstallPrompt from '@/hooks/useInstallPrompt';

export default function PWAInstallButton() {
    const { deferredPrompt } = useInstallPromptContext();
    const { mobileMode } = useContext(DeviceContext)
    const [isVisible, setIsVisible] = useState(false);
    const { IOSPopupShow, setIOSPopupShow } = useContext(SignContext)
    
    const { installApp } = useInstallPrompt();

    const locale = useLocale();
    const a = useTranslations("Sentence")

    // iOS Safari 감지
    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };
    // const isInStandaloneMode = () =>
    //     'standalone' in window.navigator && (window.navigator as any).standalone;

    // const isInStandaloneMode = () =>
    //     (window.matchMedia('(display-mode: standalone)').matches) ||
    //     ('standalone' in window.navigator && (window.navigator as any).standalone);

    const isInStandaloneMode = () => {
        return (
            // 아이폰
            ('standalone' in window.navigator && (window.navigator as any).standalone) ||
            // 이ㅏㄴ드로읻,
            window.matchMedia('(display-mode: standalone)').matches
        );
    };



    useEffect(() => {
        // if (isMobile) setIsVisible(true);
        console.log("Buttion", deferredPrompt)

        if (isInStandaloneMode()) {
            setIsVisible(false)
            return;
        } else {
            if (mobileMode) {
                setIsVisible(true)
            }

        }
    }, []);

    const handleInstallClick = async () => {

        // !isInStandaloneMode() 이미 설치된 환경인지
        // isIos() IOS 인지 확인 후 설치 안내 팝업
        if (isIos() && !isInStandaloneMode()) {
            setIOSPopupShow(true)
            return;
        }

        // InstallPromptProvider 에서 전역으로 선언된 beforeinstallprompt 이벤트 사용
        // ※※ 이렇게 변경 된 이유 ※※
        // 최근(5/5) 크롬 업데이트로 인데 간접적으로 영향을 받아서 beforeinstallprompt 이벤트는 1회성 이벤트라 한 면 등록 되면 사라지는 현상이 발생.
        // 즉, 이벤트가 등록 되는 시점이 컴포넌트에 있으면 타이밍을 잴 수가 없어서 곧바로 감지하고 받을 수 가 없음
        // 그런데 layout 부분에서 가장 빠르게 선언하면 이벤트 호출 가능. > 그걸 전역으로 저장 하여 하위에서 사용.
        console.log("Event", deferredPrompt)

        installApp();
        // if(deferredPrompt) {
        //     // install
        //     // 설치 팝업 띄우기
        //     await deferredPrompt.prompt();

        //     const choiceResult = await deferredPrompt.userChoice;
        // }else {
        //     // 크롬/사파리 제외 브라우저
        //     customAlert((a.rich("unsupportedA2HS", { br: (c) => <br /> }) as string), 'warning',
        //         () => { redirectInappToChrome(false, locale) }, { htmlMode: true }
        //     )
        // }
        // console.log('User response:', choiceResult.outcome);

        // 설치 버튼 숨기기
        // deferredPrompt.current = null;
        // setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <button
            onClick={handleInstallClick}
            className="pwa-button" >
            <img src={`image/etc/add_home_${locale}.png`} alt="" />
            {/* 홈 화면에 설치 */}
        </button>
    );
};